import HttpService from "./HttpService";
const API_ENDPOINT = "/ess-project";

const MyProjectService = {
  async getProjects() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default MyProjectService;
